import { z } from "zod";
import { uuidv7 } from "uuidv7";

declare const accrualImporterExtractionIdBrand: unique symbol;

export type AccrualImporterExtractionId = string & {
    [accrualImporterExtractionIdBrand]: true;
};

const extractionIdSchema = z.string().uuid();

export function isAccrualImporterExtractionId(
    value: string,
): value is AccrualImporterExtractionId {
    return extractionIdSchema.safeParse(value).success;
}

export function parseAccrualImporterExtractionId(
    value: string,
): AccrualImporterExtractionId | null {
    const trimmedExtractionId = value.trim();
    if (!isAccrualImporterExtractionId(trimmedExtractionId)) {
        return null;
    }
    return trimmedExtractionId;
}

export function createAccrualImporterExtractionId(): AccrualImporterExtractionId {
    const extractionId = uuidv7();
    if (!isAccrualImporterExtractionId(extractionId)) {
        throw new Error("Failed to generate accrual importer extraction id");
    }
    return extractionId;
}

export function accrualImporterExtractionIdFromPersisted(
    persistedExtractionId: string,
): AccrualImporterExtractionId {
    const parsedExtractionId = parseAccrualImporterExtractionId(
        persistedExtractionId,
    );
    if (!parsedExtractionId) {
        throw new Error("Persisted extraction id must be a UUID");
    }
    return parsedExtractionId;
}
